module.exports = __webpack_public_path__ + "static/media/Notes_Icon.54597dbd.svg";